import styled from 'styled-components';
import { Popconfirm as AntPopconfirm } from 'antd';

export const Popconfirm = styled(AntPopconfirm)``;
